document.addEventListener("DOMContentLoaded", function () {
    const track = document.querySelector('.slider-track'); // Selecciona el contenedor de imágenes
    let scrollAmount = 0;
    let slideWidth = document.querySelector('.slider-img').offsetWidth + 10; // Ancho de cada imagen + gap

    function slide() {
        scrollAmount -= slideWidth; // Mueve hacia la izquierda

        if (Math.abs(scrollAmount) >= track.scrollWidth / 2) {
            scrollAmount = 0; // Reinicia para bucle infinito
        }

        track.style.transform = `translateX(${scrollAmount}px)`;
    }

    setInterval(slide, 3000); // Cambia cada 3 segundos
});
